import type { ReactElement } from 'react';

import get from 'lodash/get';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import ReviewImage from '../ReviewImage';

import type { ImagesItem, ImagesListClickEventHandler } from '../../types';

import STYLES from './ReviewImagesSwiper.module.scss';

import Swiper from '@shared/ui/common/Swiper';

const cls = cssModules(STYLES);
const PAGE_SIZE_FOR_ALL_REVIEWS = 6;
const PAGE_SIZE_FOR_SPECIFIC_REVIEW = 4.5;
const PAGE_GROUP_COUNT = 1;

type Props = {
  images: ImagesItem[];
  showAllTravellerImages?: boolean;
  onClick?: ImagesListClickEventHandler;
  className?: string;
  reviewIndex?: number;
};
const ReviewImagesSwiper = ({
  className,
  images,
  onClick,
  reviewIndex,
  showAllTravellerImages,
}: Props) => {
  const imageCount = images.length;
  if (imageCount === 0) {
    return null;
  }

  const imageItems = images.map(({ src }, index) => (
    <ReviewImage
      key={src}
      src={src}
      imageIndex={index}
      reviewIndex={reviewIndex}
      onClick={(e) => onClick?.(e, index)}
    />
  ));

  const imageGroups = imageItems
    .reduce((groups, card, idx) => {
      const x = Math.floor(idx / PAGE_SIZE_FOR_ALL_REVIEWS);
      const y = idx % PAGE_SIZE_FOR_ALL_REVIEWS;
      if (!groups[x]) {
        // eslint-disable-next-line no-param-reassign
        groups[x] = [];
      }
      // eslint-disable-next-line no-param-reassign
      groups[x][y] = card;
      return groups;
    }, [] as ReactElement[][])
    .map((item, idx) => (
      <section key={get(item, '0.key', idx)}>
        <div className={cls('ReviewImagesSwiper__item')}>{item}</div>
      </section>
    ));

  return (
    <div
      className={cls('ReviewImagesSwiper', className)}
      data-test-id="review-all-images-swiper"
    >
      <Swiper
        prevNavBtnClassName={cls('ReviewImagesSwiper__swiperPrevNavBtn')}
        nextNavBtnClassName={cls('ReviewImagesSwiper__swiperNextNavBtn')}
        itemsPerGroup={
          showAllTravellerImages
            ? PAGE_GROUP_COUNT
            : PAGE_SIZE_FOR_SPECIFIC_REVIEW
        }
        spaceBetween={0}
        buttonPosition="outer"
        className={cls('ReviewImagesSwiper__swiperWrapper')}
      >
        {showAllTravellerImages ? imageGroups : imageItems}
      </Swiper>
    </div>
  );
};

export default ReviewImagesSwiper;
